export class NotSupportedError extends Error {
  constructor(value: string) {
    super(`The "${value}" is not supported.`);
  }
}